export default __webpack_public_path__ + "static/media/confirm-activate.5ad134a9.svg";